import { render } from "./HealthChart.vue?vue&type=template&id=2df3396e"
import script from "./HealthChart.vue?vue&type=script&lang=js"
export * from "./HealthChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__